import React from "react";
import Icon from "./Icons";
import { useTranslation } from "../../context/TranslationContext";

const Pool = ({ title, boy, genislik, derinlik }) => {
  const { poolLength, poolWidth, poolDepth } = useTranslation();
  if (boy)
    return (
      <div className="flex flex-wrap bg-DetailVideoBg lg:pt-10 lg:pb-9 py-6 px-5 md:pl-7 lg:pl-8 rounded-lg text-white md:w-1/3 bg-red-200">
        <span className="flex items-start xl:items-center text-base xl:mb-5">
          <span className="mr-4">
            <Icon name="DetailPool" />
          </span>
          <span className="-mt-1.5 xl:mt-0">{title}</span>
        </span>
        <div className="flex lg:flex-col xl:flex-col w-full gap-x-8 pl-12 ml-1 xl:ml-0 xl:pl-0 -mt-6 xl:mt-0 flex-col">
          <div className="flex">
            <span className="xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0">{poolLength}</span>
            <span className="xl:w-1/2 mt-2 ml-auto">{boy}</span>
          </div>
          <div className="flex">
            <span className="xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0">{poolWidth}</span>
            <span className="xl:w-1/2 mt-2 ml-auto">{genislik}</span>
          </div>
          <div className="flex">
            <span className="xl:w-1/2 mt-2 opacity-50 mr-2 xl:mr-0">
              {poolDepth}
            </span>
            <span className="xl:w-1/2 mt-2 ml-auto">{derinlik}</span>
          </div>
        </div>
      </div>
    );
};

export default Pool;
